import ResumeLink from './component.styles'
export default ResumeLink
